import { ref, set } from "@firebase/database";
import { PATHS } from "shared";
import { database } from "../../firebase/constants/database";
import type { RegisteredDevice } from "../types/RegisteredDevice";

export const setToken = async (
  userId: string,
  token: string
): Promise<void> => {
  const db = database;
  if (!db) {
    throw new Error("No Firebase database connection to use");
  }
  const tokenRef = ref(db, PATHS.messagingToken(userId, token));
  const registeredDevice: RegisteredDevice = {
    timestamp: new Date().getTime(),
    userAgent: navigator.userAgent,
  };
  await set(tokenRef, registeredDevice);
};
